import { render, staticRenderFns } from "./Question1.vue?vue&type=template&id=35e6467a&scoped=true&"
import script from "./Question1.vue?vue&type=script&lang=js&"
export * from "./Question1.vue?vue&type=script&lang=js&"
import style0 from "./Question1.vue?vue&type=style&index=0&id=35e6467a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6467a",
  null
  
)

export default component.exports